import { Box, HStack, LucideIcon } from '@skin-seoul/design-system';
import DesktopProductCard from './cards/DesktopProductCard';
const RecentlyViewProductCarouselSkeleton = () => {
  return <Box width="100%" display={{
    base: 'none',
    tablet: 'flex'
  }} flexDirection="column" gap={12} data-sentry-element="Box" data-sentry-component="RecentlyViewProductCarouselSkeleton" data-sentry-source-file="RecentlyViewProductCarousel.skeleton.tsx">
      <HStack position="relative" width="100%" justifyContent="space-between" data-sentry-element="HStack" data-sentry-source-file="RecentlyViewProductCarousel.skeleton.tsx">
        <LucideIcon color="primary.400" name="ChevronLeft" boxSize={11} strokeWidth={1} opacity={0.3} data-sentry-element="LucideIcon" data-sentry-source-file="RecentlyViewProductCarousel.skeleton.tsx" />
        <DesktopProductCard.Skeleton data-sentry-element="DesktopProductCard.Skeleton" data-sentry-source-file="RecentlyViewProductCarousel.skeleton.tsx" />
        <LucideIcon color="primary.400" name="ChevronRight" boxSize={11} strokeWidth={1} opacity={0.3} data-sentry-element="LucideIcon" data-sentry-source-file="RecentlyViewProductCarousel.skeleton.tsx" />
      </HStack>
    </Box>;
};
export default RecentlyViewProductCarouselSkeleton;